import gsap from 'gsap'
import {detectedDevice} from 'detected-device'
import {validDigits, minicart, riseAndFadeIn, riseAndFadeOut, isAllMobileDevices} from './bundle'
import {addToCart} from './CartFunctions'

class EventiFestival {
	constructor(container, awdScroll) {
		this.header = document.querySelector('header')
		this.container = container
		this.awdScroll = awdScroll
		this.globalIsAnimating = false

		this.colorBlack = '#121213'
		this.colorWhite = '#ffffff'

		this.eventi = [...this.container.querySelectorAll('.evento:not(.soldout)')]
		this.popups = [...this.container.querySelectorAll('.popup-acquista')]

		this.initEvents()
	}

	initEvents() {
		this.eventi.forEach((evento) => {
			evento.addEventListener('mouseenter', () => {
				if(evento.classList.contains('non-vendibile-online')) return
				this.hoverEvento(evento)
			});
			evento.addEventListener('mouseleave', () => {
				if(evento.classList.contains('non-vendibile-online')) return
				this.leaveEvento(evento)
			});
			let eventoWrapperTitle = evento.querySelector('.evento__header')
			eventoWrapperTitle.addEventListener('click', () => {
				if(evento.classList.contains('non-vendibile-online')) return
				if (this.globalIsAnimating) return
				this.globalIsAnimating = true

				let curHeight = this.calculateEventoHeight(evento)

				if (evento.classList.contains('open')) {
					this.closeEvento(evento);
				}else {
					this.openEvento(evento, curHeight);
				}
			})

			// let btnAddToCartEvent = evento.querySelector('.buy-actions__cta-add-to-cart')
			// btnAddToCartEvent.addEventListener('click', () => {
			// 	//* ADD TO CART
			// 	console.log(btnAddToCartEvent.dataset.productId)
			// });

			if(evento.querySelector('.buy-actions__qty .qty__number .input-qty') !== null){
				let qntLess = evento.querySelector('.buy-actions__qty .qty__action--remove')
				let qntValue = evento.querySelector('.buy-actions__qty .qty__number .input-qty')
				let qntMore = evento.querySelector('.buy-actions__qty .qty__action--add')
				let btnAdd = evento.querySelector('.buy-actions__cta-add-to-cart')
	
				if(evento.classList.contains('has-hours')){
					this.toggleHoursEvent(evento, btnAdd, qntValue)
				}
	
				this.toggleQtyBtns(qntValue, qntLess, qntMore, btnAdd)
				this.selectQty(qntValue, qntLess, qntMore, btnAdd)
				this.toggleResourceCheckbox(evento, btnAdd)
	
				btnAdd.addEventListener('click', () => {
					if(!btnAdd.classList.contains('is-waiting')){
						this.clickAddToCartBtn(btnAdd)
					}
				})

			}
			
		})
		this.popups.forEach((popup) => {
			this.toggleButtonAfterSelectonPopup(popup)
			this.setRelatedEventDataOnAddToCartButton(popup)

			let change = popup.closest('.buy-actions__flex').querySelector('.buy-actions__services .services-result .change-option')
			change.addEventListener('click', () => {
				this.openPopupAcquista(popup)
			})
		})
	}

	toggleHoursEvent(evento, button, qntValue) {
		let radios = evento.querySelectorAll('.buy-actions__select-hours .radio-list .custom-radio:not(.not-bookable)');
		[...radios].forEach((radio) => {
			let input = radio.querySelector('label input[type="radio"]');
			input.addEventListener('change', (ev) => {
				if(button.classList.contains('is-waiting')){
					button.classList.remove('is-waiting')
				}
				if(ev.currentTarget.checked) {
					button.dataset.from = ev.currentTarget.value
					button.dataset.postiDisponibili = ev.currentTarget.dataset.availability
					if(parseInt(qntValue.value) > parseInt(ev.currentTarget.dataset.availability)){
						button.dataset.productQty = 1
						qntValue.value = 1
					}
				}
			})
		})
	}

	toggleButtonAfterSelectonPopup(popup){
		let radioList = popup.querySelectorAll('.buy-actions__hourpicker .caption .radio-list .custom-radio');
		[...radioList].forEach((radio) => {
			let input = radio.querySelector('label input[type="radio"]');
			input.addEventListener('change', (ev) => {
				//let custom = input.closest('label').querySelector('.custom-radiobox');
				if(ev.currentTarget.checked) {
					popup.querySelector('.buy-actions__flex .add-to-cart-btn').classList.remove('is-waiting');
				}
			})
		})
	}

	toggleRelatedEventData(action, popup, from = null, prodId = null, radioName = null, availability = null){
		if(action == 'insert'){
			popup.closest('.buy-actions__flex').querySelector('.buy-actions__bottom .add-to-cart-btn').setAttribute('data-related-event-from', from);
			popup.closest('.buy-actions__flex').querySelector('.buy-actions__bottom .add-to-cart-btn').setAttribute('data-related-event-id', prodId);
			popup.closest('.buy-actions__flex').querySelector('.buy-actions__bottom .add-to-cart-btn').setAttribute('data-posti-disponibili', availability);

			let qntValue = popup.closest('.buy-actions__flex').querySelector('.buy-actions__bottom .buy-actions__qty .input-qty')

			if(parseInt(qntValue.value) > parseInt(availability)){
				popup.closest('.buy-actions__flex').querySelector('.buy-actions__bottom .add-to-cart-btn').setAttribute('data-product-qty', 1)
				qntValue.value = 1
			}

			popup.closest('.buy-actions__flex').querySelector('.buy-actions__services .services-result .string em').innerHTML = popup.querySelector('input[name="' + radioName + '"]:checked').dataset.hour;

			if(popup.closest('.buy-actions__flex').querySelector('.buy-actions__services .services-result').classList.contains('hidden')){
				popup.closest('.buy-actions__flex').querySelector('.buy-actions__services .services-result').classList.remove('hidden')
			}

		}
		if(action == 'remove'){
			popup.closest('.buy-actions__flex').querySelector('.buy-actions__services .services-result').classList.add('hidden')

			popup.querySelector('.buy-actions__flex .add-to-cart-btn').classList.add('is-waiting');

			popup.closest('.buy-actions__flex').querySelector('.buy-actions__bottom .add-to-cart-btn').removeAttribute('data-related-event-from')
			popup.closest('.buy-actions__flex').querySelector('.buy-actions__bottom .add-to-cart-btn').removeAttribute('data-related-event-id')

			let radios = popup.querySelectorAll('.buy-actions__hourpicker .custom-radio');
			[...radios].forEach((radio) => {
				radio.querySelector('input[type="radio"]').checked = false;
			})
		}
	}
	
	setRelatedEventDataOnAddToCartButton(popup){
		let btn = popup.querySelector('.buy-actions__flex .add-to-cart-btn');
		btn.addEventListener('click', () => {
			if(!btn.classList.contains('is-waiting')){
				let radios = btn.closest('.buy-actions__flex').closest('.buy-actions__center').querySelectorAll('.buy-actions__hourpicker .caption .radio-list .custom-radio');
				let radioName = radios[0].querySelector('input').getAttribute('name');
				let value = popup.querySelector('input[name="' + radioName + '"]:checked').value;
				let availability = popup.querySelector('input[name="' + radioName + '"]:checked').dataset.availability;

				this.toggleRelatedEventData('insert', popup, value, btn.dataset.product, radioName, availability)

				this.closePopupAcquista(popup)
			}
		})
	}

	calculateEventoHeight(evento) {
		return evento.querySelector('.evento__content').getBoundingClientRect().height
	}

	hoverEvento(evento) {
		if (evento.classList.contains('open') || detectedDevice.isAllMobileDevices()) return
		this.paint(evento)
	}

	leaveEvento(evento) {
		if (evento.classList.contains('open') || detectedDevice.isAllMobileDevices()) return
		this.clean(evento)
	}

	paint(evento) {
		let switchableColorText = [...evento.querySelectorAll('.js-switch-color')]
		let plus = evento.querySelector('.icon .plus')
		let plusSvg = [...plus.querySelectorAll('.svg-plus')]
		let eventoBg = evento.querySelector('.bg-evento')

		gsap.to(switchableColorText, {
			duration: 0.4,
			color: this.colorBlack,
			ease: 'power1.inOut'
		})
		gsap.to(plusSvg, {
			duration: 0.4,
			fill: this.colorBlack,
			ease: 'power1.inOut'
		})
		gsap.to(eventoBg, {
			duration: 0.4,
			height: '100%',
			ease: 'power1.inOut'
		})
	}

	clean(evento) {
		let switchableColorText = [...evento.querySelectorAll('.js-switch-color')]
		let plus = evento.querySelector('.icon .plus')
		let plusSvg = [...plus.querySelectorAll('.svg-plus')]
		let eventoBg = evento.querySelector('.bg-evento')
		
		gsap.to(switchableColorText, {
			duration: 0.4,
			color: this.colorWhite,
			ease: 'power1.inOut'
		})
		gsap.to(plusSvg,{
			duration: 0.4,
			fill: this.colorWhite,
			ease: 'power1.inOut'
		})
		gsap.to(eventoBg, {
			duration: 0.4,
			height: '0%',
			ease: 'power1.inOut'
		})
	}

	openEvento(evento, curHeight) {
		evento.classList.add('current')

		let eventoWrapperTitle = evento.querySelector('.evento__header')
		let eventoContainer = evento.querySelector('.evento__body')

		this.paint(evento)

		let headerHeight = -eventoWrapperTitle.getBoundingClientRect().height
		let plus = evento.querySelector('.icon .plus')

		gsap.to(eventoContainer, {
			duration: 0.6,
			height: curHeight,
			ease: 'Power2.inOut',
			onComplete: () => {
				evento.classList.remove('current');
				this.globalIsAnimating = false;
				this.awdScroll.update()
				/* if(detectedDevice.isMobile() == 'portrait'){
					console.log('portrait')
					let container2 = document.querySelector('#container')
					gsap.to(container2, {
						duration:0.5,
						ease:'power2.inOut',
						scrollTo: {
							y: eventoWrapperTitle,
							offsetY:headerHeight
						}
					})
				}
				else{ */
					this.awdScroll.scrollTo(eventoWrapperTitle, {
						offset: -headerHeight,
						// offset:500,
						duration: 500,
						easeing: [1, 0, 0, 1]
					});
				/* } */
			}
		});

		gsap.to(plus, {
			duration: 0.4,
			rotation: 45,
			ease: 'power1.inOut'
		})

		evento.classList.add('open');
		this.closeAltriEventi();
	}

	closeEvento(evento) {
		if (evento.classList.contains('open')) {

			let eventoContainer = evento.querySelector('.evento__body')
			let plus = evento.querySelector('.icon .plus')

			this.clean(evento)
			gsap.to(eventoContainer, {
				duration: 0.8,
				height: 0,
				onComplete: () => {
					this.globalIsAnimating = false;
					this.awdScroll.update()
				}
			});

			gsap.to(plus, {
				duration: 0.4,
				rotation: 0,
				ease: 'power1.inOut'
			})
			evento.classList.remove('open');
		}
	}

	closeAltriEventi() {
		this.eventi.forEach(evento => {
			if (!evento.classList.contains('current')) {
					let eventoContainer = evento.querySelector('.evento__body')
					let eventoBg = evento.querySelector('.bg-evento')
					// let titolo = evento.querySelector('.titolo')
					let plus = evento.querySelector('.plus')
					let plusSvg = [...evento.querySelectorAll('.svg-plus')]
					let switchableColorText = [...evento.querySelectorAll('.js-switch-color')]
					gsap.to(switchableColorText, {
							duration: 0.4,
							color: this.colorWhite,
							ease: 'power1.inOut'
					})
					gsap.to(plusSvg,{
							duration: 0.4,
							fill: this.colorWhite,
							ease: 'power1.inOut'
					})

					gsap.to(eventoBg, {
							duration: 0.15,
							height: '0%',
							ease: 'power1.inOut'
					})

					gsap.to(plus, {
							duration: 0.3,
							rotation: 0,
							ease: 'power1.inOut'
					})
					gsap.to(eventoContainer, {
							duration: 0.8,
							height: 0
					});
					evento.classList.remove('open');
			}
		})
	}

	toggleQtyBtns(inputQty, removeQtyBtn, addQtyBtn, btnAdd){

		let disTot = parseInt(btnAdd.dataset.postiDisponibili)

		if(inputQty.value <= 1){
			removeQtyBtn.classList.add('disabled')
		}else{
			removeQtyBtn.classList.remove('disabled')
		}

		if(inputQty.value >= disTot){
			addQtyBtn.classList.add('disabled')
		}else{
			addQtyBtn.classList.remove('disabled')
		}
	}

	selectQty(inputQty, removeQtyBtn, addQtyBtn, btnAdd){
		addQtyBtn.addEventListener('click', () => {

			let qntSel = parseInt(inputQty.value)
			let disTot = parseInt(btnAdd.dataset.postiDisponibili)

			if(qntSel >= disTot) return

			let qn = qntSel + 1
			inputQty.value = qn

			btnAdd.setAttribute('data-product-qty',qn)
			this.toggleQtyBtns(inputQty, removeQtyBtn, addQtyBtn, btnAdd)
		})
		
		removeQtyBtn.addEventListener('click', () => {

			let qntSel = parseInt(inputQty.value)

			if(qntSel < 2) return
			
			let qn = qntSel - 1
			inputQty.value = qn

			btnAdd.setAttribute('data-product-qty',qn)
			this.toggleQtyBtns(inputQty, removeQtyBtn, addQtyBtn, btnAdd)
		})
		inputQty.addEventListener('keyup', () => {

			let qntSel = parseInt(inputQty.value)
			let disTot = parseInt(btnAdd.dataset.postiDisponibili)

			inputQty.value = gsap.utils.clamp(1, disTot, qntSel)
			
			let field = inputQty.value
			inputQty.value = validDigits(field)
			
			let quantitaSelezionata = inputQty.value

			btnAdd.setAttribute('data-product-qty',quantitaSelezionata)
			this.toggleQtyBtns(inputQty, removeQtyBtn, addQtyBtn, btnAdd)

		})
		inputQty.addEventListener('blur', () => {
			let field = inputQty.value
			if (field == '') {
				inputQty.value = 1
			}
			let quantitaSelezionata = inputQty.value
			btnAdd.setAttribute('data-product-qty',quantitaSelezionata)
		})
	}

	toggleResourceCheckbox(evento, btnAdd) {
		if(evento.classList.contains('has-services')){
			let resourceCheck = evento.querySelector('.buy-actions__flex .buy-actions__services label input[type="checkbox"]')

			resourceCheck.addEventListener('change', (ev) => {
				let customCheck = resourceCheck.closest('label').querySelector('.services-custom-box')
				if(ev.currentTarget.checked) {

					let pop = evento.querySelector('.buy-actions__flex .popup-acquista')
					this.openPopupAcquista(pop)

					customCheck.classList.add('checked')
				}else{
					customCheck.classList.remove('checked')

					let pop = evento.querySelector('.buy-actions__flex .popup-acquista')
					this.toggleRelatedEventData('remove', pop)
				}
			})
		}
	}

	clickAddToCartBtn(addToCartBtn){
		let from = addToCartBtn.getAttribute('data-from')

		let sizeId = addToCartBtn.getAttribute('data-size-id')
		let productId = addToCartBtn.getAttribute('data-product-id')
		let qty = Number(addToCartBtn.getAttribute('data-product-qty'))

		minicart.beforeOpen()

		let checkRelEv = addToCartBtn.closest('.buy-actions__bottom').closest('.buy-actions__flex').querySelector('.buy-actions__services label .resource-check');

		if(checkRelEv?.checked){

			let relFrom = addToCartBtn.getAttribute('data-related-event-from')
			let relId = addToCartBtn.getAttribute('data-related-event-id')

			addToCart(productId, sizeId, qty, from).then(() => {
				addToCart(relId, sizeId, qty, relFrom).then(() => {
					minicart.open().then( () => {
						//this.isAnimating = false
					})
				})
			})
		}else{
			addToCart(productId, sizeId, qty, from).then(() => {
				minicart.open().then( () => {
					//this.isAnimating = false
				})
			})
		}

		
	}

	openPopupAcquista(popupAcquista){
		this.awdScroll.stop()
		this.header.classList.remove('active')
		this.header.classList.add('header-bloccato')

		let popupAcquistaContainer = popupAcquista.querySelector('.popup-acquista__container')
		let popupAcquistaBg = popupAcquista.querySelector('.popup-acquista__bg span')
		let popupAsideBuyActionsBg = popupAcquista.querySelector('.buy-actions__bg span')
		let closePopupAcquistaBtn = popupAcquista.querySelector('.buy-actions__close--btn')
		let popupAsideBuyActionsWrapper = popupAcquista.querySelector('.buy-actions__center')

		popupAcquista.classList.add('opened')
		// this.openPopupAcquistaBtn.querySelector('.button--border').classList.add('active')
		let zIndex = 19
		if(isAllMobileDevices){
			zIndex = 3900
			document.querySelector('body').style.overflow = 'hidden'
		}
		gsap.set(popupAcquista,{
				'pointer-events': 'auto',
				'z-index': zIndex
		})
		gsap.set(popupAcquistaContainer,{
				y: '0%'
		})
		gsap.to(popupAcquistaBg, {
				duration: 1.2,
				width: '100%',
				ease: 'power2.inOut'
		})
		gsap.to(popupAsideBuyActionsBg,{
				duration: 1.2,
				delay: 0.4,
				width: '100%',
				ease: 'power2.inOut'
		})
		riseAndFadeIn(closePopupAcquistaBtn,{delay: 0.8})
		riseAndFadeIn(popupAsideBuyActionsWrapper, {delay: 1.2})

		closePopupAcquistaBtn.addEventListener('click', () => { this.closePopupAcquista(popupAcquista) })
		//popupAsideBuyActionsBg.addEventListener('click', () => this.closePopupAcquista(popupAcquista))
	}

	closePopupAcquista(popupAcquista){
		let popupAcquistaBg = popupAcquista.querySelector('.popup-acquista__bg span')
		let popupAsideBuyActionsBg = popupAcquista.querySelector('.buy-actions__bg span')
		let closePopupAcquistaBtn = popupAcquista.querySelector('.buy-actions__close--btn')
		let popupAsideBuyActionsWrapper = popupAcquista.querySelector('.buy-actions__center')

		riseAndFadeOut(closePopupAcquistaBtn,{destination: 0})
		riseAndFadeOut(popupAsideBuyActionsWrapper)

		gsap.to(popupAsideBuyActionsBg,{
			duration: 0.6,
			delay: 0.4,
			width: '0%',
			ease: 'power2.inOut'
		})
		gsap.to(popupAcquistaBg, {
			duration: 0.8,
			delay: 0.45,
			width: '0%',
			ease: 'power2.inOut',
			onComplete: () => {
				this.resetPopupAcquista(popupAcquista)
				//this.resetDefaltValues()
				if(isAllMobileDevices){
					document.querySelector('body').style.overflow = 'visible'
				}
			}
		})

		let radioList = popupAcquista.querySelectorAll('.buy-actions__hourpicker .caption .radio-list .custom-radio input[type="radio"]:checked');
		if(radioList.length == 0){
			let evento = popupAcquista.closest('.buy-actions__flex').closest('.right').closest('.flex').closest('.evento__content').closest('.evento__wrapper').closest('.evento')
			let check = evento.querySelector('.buy-actions__flex .buy-actions__services label input[type="checkbox"]')
			check.checked = false

			let customCheck = check.closest('label').querySelector('.services-custom-box')
			customCheck.classList.remove('checked')
		}
	}

	resetPopupAcquista(popupAcquista){

		let popupAcquistaContainer = popupAcquista.querySelector('.popup-acquista__container')
		this.awdScroll.start()
		this.header.classList.add('active')
		this.header.classList.remove('header-bloccato')

		popupAcquista.classList.remove('opened')
		gsap.set(popupAcquista,{
				'pointer-events': 'none',
				'z-index': -1
		})
		gsap.set(popupAcquistaContainer,{
				y: '-100%'
		})
	}
}

export {EventiFestival}